function LoadingComponent() {
    return (
        <div className="flex justify-center items-center col-span-full py-10">
            <div className="w-12 h-12 border-4 border-solid border-gray-300 border-t-[#003D42] rounded-full animate-spin"></div>
          </div>
    )
}

export default LoadingComponent